import DavidProfile from "../../images/bitcoin-live/profile - David Schmierer.png";
import Charis from "../../images/bitcoin-live/Charis_Louca.JPG";
import Linda from "../../images/bitcoin-live/Linda_Simpson.jpg";
import Jonathan from "../../images/bitcoin-live/Jonathan_Garcia.png";
import Nhial from "../../images/bitcoin-live/Nhial_Majok.png";
import Sally from "../../images/bitcoin-live/Sally_Dipple.jpeg";
import Tobias from "../../images/bitcoin-live/Tobias_Hagehei.jpeg";
import Bobby from "../../images/bitcoin-live/Bobby_Brasco.png";
import Ulrich from "../../images/bitcoin-live/Ulrich_Wagener.jpg";
import Hector from "../../images/bitcoin-live/Hector_Gonzalez.jpeg";
import Paul from "../../images/bitcoin-live/Donnie.png";
import Laith from "../../images/bitcoin-live/Laith_Abdulilah.jpeg";

export const testinomials = [
  {
    name: "David Schmierer",
    content:
      "Patience and discipline as a trader are needed to survive the volatility of crypto. Without Bitcoin Live I would've given up on crypto in 2022!",
    profilePic: DavidProfile
  },
  {
    name: "Ulrich J Wagener",
    content:
      "The most complete view of the crypto markets from five seasoned analysts, varying in analytical style and trading methodology. Trading will not be the same without Bitcoin Live!",
    profilePic: Ulrich
  },
  {
    name: "Charis",
    content:
      "Excellent analysis from every member of the team. Taught me how to protect my investment  when I really needed it. Been here 4 years - worth every penny.",
    profilePic: Charis
  },
  {
    name: "Linda Simpson",
    content:
      "I've been happily following the Bitcoin Live team for 2 years and my Crypto journey has been much smoother, more knowledgable and less disruptive. The Bitcoin Live team are unique in their sharing of information and explanations.",
    profilePic: Linda
  },
  {
    name: "Jonathan",
    content:
      "In a market that is full of charlatans and poor leadership, BTC Live emerges as the spearhead that cuts through the noise and delivers nothing but truth and accuracy. It's a service based on experience that has educated me in ways a university can't.",
    profilePic: Jonathan
  },
  {
    name: "Nhial Majok",
    content:
      "I joined Bitcoin live during the depths of the 2018 Bear Market after I messed up not selling. Since then they have more than filled my knowledge gap and I have been a member for 4 years straight now, great mature team.",
    profilePic: Nhial
  },
  {
    name: "Sally Dipple",
    content:
      "I am a hodler not a trader. However, after cumulative learning over 2 years from Bob I succeeded both in taking profit and also modestly increasing my portfolio, during the last bull and bear runs. I would never have known how to take the appropriate action , or had the confidence to do it without the support of Bitcoin Live.",
    profilePic: Sally
  },
  {
    name: "Tobias.eth",
    content:
      "Bitcoin live has helped me understand how my emotions impact the trade. They give the whole picture and not only technical analysis.",
    profilePic: Tobias
  },
  {
    name: "Bobby Levene",
    content:
      "Bob Loukas was instrumental in getting me back in the market near the lows of 2019. Peter Brandt called the top in 2018 and Dean and Cheds cashed out near the tops in 2021. I’m becoming a better trader and investor each cycle, from both a technical and physiological perspective. It’s mainly thanks to this service.",
    profilePic: Bobby
  },
  {
    name: "Hector G aka trading$chimp",
    content:
      "If there is one thing I have learned from the BL team is to be patient, to trade with confidence and a solid plan. The team is so well balanced and the trading styles vary in such an amazing way that you can learn what works best for you",
    profilePic: Hector
  },
  {
    name: "Paul Donoghue",
    content:
      "Level headed, clear, regular updates that keep the fomo in check. I have been investing/trading for a reasonable amount of time and the benefit of being part of bitcoin.live has been monumental, to my overall trade plan.",
    profilePic: Paul
  },
  {
    name: "Laith Abdulrahman",
    content:
      "I got rescued from loosing all my trades, all the team and their posts made me learn everyday a new skill and make the right decisions in all market cycles, I feel lucky to make the decision to subscribe in Bitcoin Live",
    profilePic: Laith
  }
];
